'use strict';

// Constructor
var Header = function () {
    $(".page-node-type-book-cover header").append("<div class='mobile-menu-click'> <h2>Contents</h2> </div>")
    $('.page-node-type-book-cover header .a-aspiLogo').append("<h2 class='desktop'>Australian Strategic Policy Institute</h2>");
    $('.page-node-type-book-cover header .a-aspiLogo').append("<h2 class='mobile'>aspi</h2>");
    
};

module.exports = Header;
